// packages/data/src/plugins/index.ts
import { default as default2 } from "./persistence/index.mjs";
export {
  default2 as persistence
};
//# sourceMappingURL=index.mjs.map
